import styled from 'styled-components'
import { theme } from '@/client/components'
import font from '@/client/components/theme/font'
const { borders, color, space, breakpoint } = theme

export const FileChecker = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${space.lg};

  .collapse-header-ch {
    font-weight: ${font.weight.bold} !important;
  }

  .collapse-header-ch,
  .collapse-children-ch {
    color: black;
    line-height: 1.2;
  }

  @media (min-width: ${breakpoint.xl}) {
    width: 49%;
    border-radius: ${borders.radius.xl};

    .collapse-header-ch {
      padding: 3rem 0 0;
    }

    .collapse-children-ch {
      padding: 1rem 0 0;
    }

    .collapse-childre .collapse-content-ch {
      height: auto;
    }

    top: -5rem;
  }
`

export const Form = styled.div`
  padding: ${space.xl} ${space.xl2};
  background-color: ${color.grayscale.ghostWhite};
  border-radius: 0 0 ${borders.radius.lg} ${borders.radius.lg};
  position: relative;

  .upload-icon {
    font-size: 6rem !important;
    font-weight: 900 !important;
    margin-top: 5rem;
    display: flex;
    justify-content: center;
  }
`

export const Block = styled.div`
  padding-bottom: ${space.xl3};
`

export const Option = styled.div<{ direction?: string; isFull?: boolean }>`
  display: flex;
  flex-direction: ${(p) => p.direction ?? 'row'};
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: ${(p) => (p.isFull ? 'nowrap' : 'wrap')};
  gap: ${space.sm};

  .outer-circle {
    margin-top: 1rem;
    width: 20px;
    height: 20px;
    border: 2px solid ${color.primary.turquoiseBlue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: pulsate 1s ease-out infinite;
    position: absolute;
    left: 1rem;
  }

  .inner-circle {
    width: 8px;
    height: 8px;
    background-color: ${color.primary.turquoiseBlue};
    border-radius: 50%;
  }

  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(1.2, 1.2);
      opacity: 0;
    }
  }
`

export const Hint = styled.sup`
  margin-left: ${space.xs2};
  cursor: help;
`
export const CardHeader = styled.div`
  width: 100%;
  background-color: ${color.grayscale.lavenderBlue};
  @media (min-width: ${breakpoint.lg}) {
    border-radius: ${borders.radius.xl} ${borders.radius.xl} 0 0;
    transition: border-radius 0.4s ease-in-out;
  }
`

export const DividerLine = styled.div`
  background-color: ${color.grayscale.black};
  margin-top: ${space.lg};
  margin-right: ${space.lg};
  margin-left: ${space.lg};
  width: 90%;
  height: 0.09rem;

  @media (min-width: ${breakpoint.md}) {
    background-color: ${color.grayscale.black};
    margin-top: ${space.lg};
    margin-right: 0;
    margin-left: 0;
    width: 100%;
    height: 0.09rem;
  }
`
export const TopTriangle = styled.div<{ isVisible: boolean }>`
  display: none;

  @media (min-width: ${breakpoint.xl}) {
    display: block;
    margin-bottom: ${space.xs};
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid ${color.grayscale.lavenderBlue};
    visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
    left: 50%;
    position: relative;
  }
`

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`

export const LogInModal = styled.div`
  .alert-background {
    position: absolute;
  }

  .alert-content {
    padding: 1rem 1rem 1.5rem;
  }
`
